// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"368":"af753c85","399":"b42c86d7","624":"d59646b6","738":"1c6e511f"}[chunkId] + ".css";
};